
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class JobbookingCreateSubmitBtn extends Vue {
  @Prop(Boolean) public disabled: boolean;
  @Prop(Boolean) public loading: boolean;

  public handleClick(event: SubmitEvent | PointerEvent) {
    this.$emit('click', event);
  }
}
